import { render, staticRenderFns } from "./selcarmodel.vue?vue&type=template&id=bf3c163e&scoped=true&"
import script from "./selcarmodel.vue?vue&type=script&lang=js&"
export * from "./selcarmodel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3c163e",
  null
  
)

export default component.exports